import { DefaultTheme } from 'styled-components';

import breakpoints from './breakpoints/index.js';
import colors from './colors/index.js';
import boxShadows from './boxShadows/index.js';
import spacing from './spacing/index.js';
import zIndex from './zIndex/index.js';

const theme: DefaultTheme = {
  boxShadows,
  breakpoints,
  colors,
  spacing,
  zIndex,
};

export type NucleusTheme = typeof theme;

export default theme;
